import { theme } from "@local-logic/core/ui";
import { styled } from "styled-components";

export const ScoreCategory = styled.div`
  padding: ${theme["--ll-spacing-small"]} ${theme["--ll-spacing-medium"]};
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const LoadingItemContainer = styled.div`
  margin: ${theme["--ll-spacing-small"]} 0;
`;

export const POIContainer = styled.div`
  padding: ${theme["--ll-spacing-medium"]};
  background: ${theme["--ll-color-surface"]};

  &:empty {
    margin: 0;
  }
`;
